var map = {
	"./helen/components/documents/Document": 41764,
	"./helen/components/documents/Document.jsx": 41764,
	"./helen/core/hooks/useDocumentFields": 5328,
	"./helen/core/hooks/useDocumentFields.js": 5328,
	"./helen/core/qes/constants": 17097,
	"./helen/core/qes/constants.js": 17097,
	"./helen/locales/en": 34187,
	"./helen/locales/en.js": 34187,
	"./helen/locales/fr": 48924,
	"./helen/locales/fr.js": 48924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33319;